(function() {
    'use strict';

    angular.module('eDocumentsApp').component('faqsComponent', {
        templateUrl: 'app/components/faqs/faqs.html',
        controller: 'FAQsController',
        controllerAs: 'vm'
    });
})();
